module.exports = __webpack_public_path__ + "fonts/nunito-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Nunito/nunito-regular-webfont.woff
// module id = 3447
// module chunks = 0